import { FunctionComponent } from 'react';

// import RefreshIcon from '@mui/icons-material/Refresh';
import { Box } from '@mui/material';

import QuickMobileNav from '../ui/QuickMobileNav';

const Footer: FunctionComponent = () => {
  /*
   * depricated: not in use
   */
  // const version = process.env.REACT_APP_VERSION;
  // const handleHardRefresh = (): void => {
  //   window.location.reload();
  // };

  return (
    <>
      <QuickMobileNav />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          height: '50vh',
          backgroundColor: '#121212'
          // background: 'linear-gradient(to bottom, #121212, rgba(255,2555,255, 0.10))'
        }}
      >
        <Box>
          {/* <Divider>
            <Typography variant="caption">Frontend: {`v${version}`}</Typography>
          </Divider>
          <Box sx={{ my: 3, display: 'flex', justifyContent: 'center' }}>
            <Tooltip title="Hard refresh">
              <IconButton size="small" onClick={handleHardRefresh}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          </Box> */}
        </Box>
      </Box>
    </>
  );
};

export default Footer;
